<template>
  <div :class="bem()">
    <nx-inline-loading class="loading-img" type="swivel-image"></nx-inline-loading>
  </div>
</template>

<script>
import create from '../create'
import { InlineLoading } from '@vivo/vos-ui'
export default create({
  name: 'pending',
  components: {
    [InlineLoading.name]: InlineLoading
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
